import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import logo from "../assets/images/maneandbarelogo.png";

function Footer() {
	return (
		<div className="mb-footer">
			<div className="container">
				<div className="d-flex justify-content-between align-items-center">
					<img src={logo} alt="Mane & Bare logo" className="mb-footer-logo" />
					<div className="mb-footer-links d-flex align-items-center">
						<a
							href="https://www.instagram.com/maneandbareoakville/"
							target="_blank"
							rel="noreferrer"
							className="mb-footer-link-instagram mx-1"
						>
							<FontAwesomeIcon icon={faInstagram} />
						</a>
						<a
							href="https://www.tiktok.com/@mane.bare.hair.skin?_t=ZS-8zsB8KRsCmu&_r=1"
							target="_blank"
							rel="noreferrer"
							className="mb-footer-link-tiktok mx-1"
						>
							<FontAwesomeIcon icon={faTiktok} />
						</a>
						<a
							href="https://www.google.com/maps/place/Mane+and+Bare+Hair+Skin+wellness/@43.5000572,-79.6636395,17z/data=!3m1!4b1!4m18!1m9!3m8!1s0x882b4335280f47ab:0x60b62f2092e87d9f!2sMane+and+Bare+Hair+Skin+wellness!8m2!3d43.5000533!4d-79.6610646!9m1!1b1!16s%2Fg%2F11yk9fmrgr!3m7!1s0x882b4335280f47ab:0x60b62f2092e87d9f!8m2!3d43.5000533!4d-79.6610646!9m1!1b1!16s%2Fg%2F11yk9fmrgr?entry=ttu&g_ep=EgoyMDI1MDkxNy4wIKXMDSoASAFQAw%3D%3D"
							target="_blank"
							rel="noreferrer"
							className="mb-footer-link-google mx-1"
						>
							<FontAwesomeIcon icon={faGoogle} />
						</a>
					</div>
				</div>
				<hr />
				<h6 className="d-flex justify-content-end">&copy; 2025</h6>
			</div>
		</div>
	);
}

export default Footer;
